import { ContactPhoneRow } from "services/api/contacts/types";
import { Badge } from "ui/components/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";


export const CONTACT_PHONE_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handlePhoneClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleWhatsAppClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
  handleViberClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    phone: string
  ) => void,
): Column[] => {


  return [
    {
      title: t("admin.contact.phone.search.phonenumber"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
          <>
            <div className="text-md">
              {row.phoneNumber}
            </div>
            <div className="text-sm font-light text-slate-500 truncate">
              {row.description}
            </div>
          </>
        );
      },
    },
    {
      title: t("admin.contact.phone.search.phonetype"),
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
         <div className="text-md">
            {row.phoneTypeId === "M" ? t("admin.contact.phone.search.phonetype.mobile") : t("admin.contact.phone.search.phonetype.phone")}
          </div>
        );
      },
    },
    {
      title: t("admin.contact.phone.search.primary"),
      field: "",
      type: ColumnTypes.custom,
      render: (row) => {
        return (
          <Badge text={row.primary ? "DA" : "NE"} variant={row.primary ? "success" : "danger"} />
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: ContactPhoneRow) => {
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            <ButtonMenuItem
              startIcon="/media/icons/phone.svg"
              onClick={(e) => handlePhoneClick(e, row.id)}
            >
              {t("admin.contact.phone.search.call")} ({row.phoneNumber})
            </ButtonMenuItem>
            {row.phoneTypeId === "M" && (
              <>
                <ButtonMenuItem
                  startIcon="/media/icons/whatsapp.svg"
                  onClick={(e) => handleWhatsAppClick(e, row.phoneNumber)}
                >
                   {t("admin.contact.phone.search.sendwhatsapp")}
                </ButtonMenuItem>
                <ButtonMenuItem
                  startIcon="/media/icons/viber.svg"
                  onClick={(e) => handleViberClick(e, row.phoneNumber)}
                >
                   {t("admin.contact.phone.search.sendviber")}
                </ButtonMenuItem>
              </>
            )}
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
                 {t("admin.contact.phone.search.remove")}
            </ButtonMenuItem>

          </ButtonMenu>
        );
      },
    },
  ];
};
